import type {ReactElement} from 'react';
import {useState} from 'react';
import type {NotificationsPanelDropdownProps} from './notifications-panel-dropdown.types';
import {NotificationsPanel} from '@Panels/notifications-panel/notifications-panel';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import {NotificationButton} from '@Components/notification-button/notification-button';
import styles from './notifications-panel-dropdown.module.scss';
import {useAppDispatch} from '@/hooks';
import {NotificationsPanelDisplayType} from '@Panels/notifications-panel/notifications-panel.types';
import {setPanelDisplayType} from '@Panels/notifications-panel/notifications-panel-slice';
import {useAllNotifications, useMarkAllNewNotificationsAsSeen} from '@Panels/notifications-panel/notifications-panel-hooks';
import {NOTIFICATIONS_PANEL_ID} from '@Modals/notifications-modal/notifications-modal-library';
import {GA4EventName} from '@Libraries/ga-events';

export function NotificationsPanelDropdown({...props}: NotificationsPanelDropdownProps): ReactElement {
  const [isOpen, setIsOpen] = useState(false);
  const allFilteredNotifications = useAllNotifications();
  const dispatch = useAppDispatch();
  const markAllNewNotificationsAsSeen = useMarkAllNewNotificationsAsSeen();

  const onClose = (): void => {
    if (isOpen) {
      markAllNewNotificationsAsSeen(allFilteredNotifications);
      if (allFilteredNotifications.length > 0) {
        dispatch(setPanelDisplayType(NotificationsPanelDisplayType.LOADED));
      } else {
        dispatch(setPanelDisplayType(NotificationsPanelDisplayType.EMPTY));
      }
    }
    setIsOpen(false);
  };

  return (
    <Dropdown
      onOpen={() => {
        window.PMW.gtm.trackGA4CustomEvent(GA4EventName.NOTIFICATION_NAV_CLICK);
        setIsOpen(true);
      }}
      doCloseOnInnerClick={false}
      alignment={ALIGNMENT_TYPE.BOTTOM_START}
      popUpHasCustomWidth
      popupSpacingClass={'_unpadded'}
      popupOffset={18}
      popUpHasCustomHeight
      onClose={onClose}
      selector={<NotificationButton buttonType={props.buttonType} isActive={isOpen} />}
      popup={<NotificationsPanel onClosePanel={onClose} isMobile={props.isMobile} />}
      popupClassName={styles.noMaxHeight}
      open={isOpen}
      stopClickPropagation
      panelIdForModal={NOTIFICATIONS_PANEL_ID}
    />
  );
}
